module.exports = __webpack_public_path__ + "media/images/img_top_guide02-aedca8ec39c117a00cb6885277c6e055.jpg";